import React from "react";
import { Box, Container, Heading, Text, HStack } from "@chakra-ui/react";

const Header = () => {
  return (
    <Box
      borderBottom="1px solid"
      borderColor="gray.100"
      _dark={{ borderColor: "gray.800" }}
      pb={10}
      pt={14}
    >
      <Container maxW="5xl">
        <Heading
          as="h1"
          fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
          fontWeight="800"
          letterSpacing="-0.03em"
          color="gray.900"
          _dark={{ color: "white" }}
          lineHeight="1.1"
          mb={4}
        >
          Terms &amp; Conditions
        </Heading>

        <HStack gap={6} flexWrap="wrap">
          <Text fontSize="sm" color="gray.500">
            <Text
              as="span"
              fontWeight="600"
              color="gray.700"
              _dark={{ color: "gray.300" }}
            >
              Provider:
            </Text>{" "}
            Onemind Services LLC / CloudMyLab
          </Text>
          <Text fontSize="sm" color="gray.500">
            <Text
              as="span"
              fontWeight="600"
              color="gray.700"
              _dark={{ color: "gray.300" }}
            >
              Effective:
            </Text>{" "}
            As posted at cloudmylab.com/terms-of-services
          </Text>
        </HStack>
        <Text
          fontSize="sm"
          color="gray.600"
          _dark={{ color: "gray.400" }}
          lineHeight="1.8"
          mt={6}
        >
          These Terms and Conditions govern access to and use of the CloudMyLab website,
          platform, hosted lab environments, managed hosting, backup offerings, support,
          and related services made available by Onemind Services LLC / CloudMyLab to any
          individual or entity purchasing, accessing, or using the Services.
        </Text>
        <Box
          mt={4}
          p={5}
          bg="blue.50"
          _dark={{ bg: "blue.950" }}
          borderRadius="xl"
          borderLeft="4px solid"
          borderLeftColor="blue.500"
        >
          <Text
            fontSize="sm"
            color="blue.800"
            _dark={{ color: "blue.200" }}
            lineHeight="1.7"
          >
            By accessing or using the Services, or by executing an Order, you agree to be
            bound by these Terms. If you are accepting these Terms on behalf of a company,
            government entity, school, university, or other legal entity, you represent
            that you have authority to bind that entity, and &quot;Customer&quot; means
            that entity.
          </Text>
        </Box>
      </Container>
    </Box>
  );
};

export default Header;
